import React, { useEffect, useState, useRef } from 'react';
//import { Col, Container, Row } from "reactstrap";
import { Activatetitle } from "../../utils/Constant";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { decryptData } from "../../utils/helper/Crypto";
import { Container,Card, CardBody, Col, Row, FormGroup, Input, Label, } from "reactstrap";
import { Btn } from "../../AbstractElements";
import { useSweetAlert } from '../../Context/SweetAlertContext'
import { useActivationService } from '../../Service/Activation/Activation';
import { ethers , BrowserProvider } from "ethers";
import  Web3 from 'web3';
import { useDepositFundService } from '../../Service/DepositFund/DepositFundINRAED';
import { useNavigate } from 'react-router-dom';
import Loader from '../../CommonElements/Loader/Loader';
import * as Yup from 'yup';
import { ErrorMessage, Field, Formik,Form } from 'formik';
import { TopUpinitialValues, TopUpInterface } from '../../Type/Forms/FormsType';

const ActivationComponent = () => {
  const { ExecuteProcedure,loading } = useActivationService();
      const { showAlert, ShowSuccessAlert, ShowConfirmAlert } = useSweetAlert();
  
  //const [Packageid, setPackageId] = useState<any>(0);
  const [packagesList,setPackagesList]=useState <any>([])
  //const [InvestmentAmount, setInvestmentAmount] = useState<any>(0);
  const [InvestmentAmountStatus,setInvestmentAmountStatus]=useState<boolean>(false)
  const [pageloader, setpageloader] =useState(false)

    const [FormFieldData, setFormFieldData] = useState<any>(null)
   const [ClientID, setClientID] = useState(decryptData(localStorage.getItem("clientId") as string));
   const {TopUpDAPP}= useDepositFundService();
     const [walletAddress, setWalletAddress] = useState<string | null>(null);
     const navigate=useNavigate();
   const [usdtBalance, setUsdtBalance] = useState(0);
   const [bnbBalance, setBnbBalance] = useState(0);
  
   useEffect(() => {
    GetPackage();
  }, []);

  
  
     
  
      const GetPackage = async () => {
          const param = {
              ClientId: ClientID,
              ActionMode: "GetPackage"
          }
          const obj = {
              procName: 'ManagePackage',
              Para: JSON.stringify(param),
          };
          const res = await ExecuteProcedure(obj);
          if(res!='NoRecord'){
            setPackagesList(res);
          }
          else{
            setPackagesList([]);
          }
          
      }
      const handlePackageChange = async (e: any,setFieldValue:any) => {
        const selectedPackageId = e.target.value;
       // setPackageId(selectedPackageId); // Update state
         setFieldValue("PackageId",selectedPackageId);
        if (selectedPackageId !== "0") {
            if(selectedPackageId=="1"){
                setInvestmentAmountStatus(false);

            }
            else{
                setInvestmentAmountStatus(true);
            }
            // Call the API function after the package ID is changed
            try {
                const param = {
                   PackageId: selectedPackageId,
                    ActionMode: "GetPackageAmount"
                }
                const obj = {
                    procName: 'ManagePackage',
                    Para: JSON.stringify(param),
                };
                const res = await ExecuteProcedure(obj);
                if(res!='NoRecord'){
              
                  setFieldValue("InvestmentAmount",res[0].Amount);
                  
                }
                else{
                 
                  setFieldValue("InvestmentAmount","");
                }
                // You can process the data here
            } catch (error) {
                console.error('Error fetching package details:', error);
            }
        }
        else {
           // setInvestmentAmount(0);
            setFieldValue("InvestmentAmount","");
            setInvestmentAmountStatus(true)
        }
    };

    //--------------------DAPP-----------------------------
    //Mainnet
    const contractAddress = '0xA200D4f5997Cc311f59d4C751e2C8c9aE36f99Ff'; // Contract Address
    const contractABI = [{"inputs":[{"internalType":"address","name":"_usdtTokenAddress","type":"address"},{"internalType":"address","name":"_withdrawContract","type":"address"},{"internalType":"uint256","name":"_withdrawPercentage","type":"uint256"},{"internalType":"address","name":"_owner","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnerChanged","type":"event"},{"inputs":[],"name":"autoWithdrawPer","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"changeOwner","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"deposit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"withdrawPercentage","type":"uint256"}],"name":"setAutoWithdrawPer","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newWithdrawContract","type":"address"}],"name":"setWithdrawContract","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"totalDeposit","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalWithdraw","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"toWithdrawCon","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferToWithdraw","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"transferToWithdrawContract","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"usdtToken","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"userBalances","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"withdrawContract","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"}]
    
    const usdtAddress = "0x55d398326f99059ff775485246999027b3197955"; // USDT contract address on BSC
    const usdtABI = [{ "inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "constant": true, "inputs": [], "name": "_decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "burn", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "getOwner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "mint", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "renounceOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }];
    
    useEffect(() => {
      const initialize = async () => {
        await Promise.all([connectWallet()]);
      };
    
      initialize();
    
    }, []); // Empty dependency array means this runs once when the component mounts
    
    const validationSchema = Yup.object({
        PackageId:Yup.string().required('PackageId is required'),
        InvestmentAmount:Yup.string().required('Slot Amount is required'),
      });

      const connectWallet = async () => {
        if (!window.ethereum) {
          alert("MetaMask is not installed. Please install it!");
          return;
        }
      
        try {
          const provider = new BrowserProvider(window.ethereum); // v6 syntax
          const accounts = await provider.send("eth_requestAccounts", []);
          const balanceInWei = await provider.getBalance(accounts[0]);
          const balanceInEth = ethers.formatEther(balanceInWei);
          // console.log(balanceInEth);
         
          const FordData ={
            PackageId:'',
            InvestmentAmount:''
          }
          debugger
          setFormFieldData(FordData)
          // console.log("Connected Account:", accounts[0]);
        //  USDTBalanceComponent(accounts[0]);
        setWalletAddress(accounts[0]);
        const usdtAddress = "0x55d398326f99059ff775485246999027b3197955"; // USDT contract address on BSC
       const usdtABI = [{ "inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "constant": true, "inputs": [], "name": "_decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "burn", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "getOwner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "mint", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "renounceOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }];
    
    
          const web3 = new Web3('https://bsc-dataseed.binance.org/'); // Public BSC RPC URL
    
          const myContract = new web3.eth.Contract(usdtABI, usdtAddress);
    
          try {
              if (!web3.utils.isAddress(accounts[0])) {
                  throw new Error('Invalid address format.');
              }
    
              // Fetch USDT balance
              const balance:any = await myContract.methods.balanceOf(accounts[0]).call();
              const formattedBalance = web3.utils.fromWei(balance, 'mwei'); // USDT uses 6 decimal places
    
              // Fetch BNB balance
              const bnbBalanceWei = await web3.eth.getBalance(accounts[0]);
              const formattedBalanceBNB = web3.utils.fromWei(bnbBalanceWei, 'ether'); // BNB uses 18 decimals
    
              // Format the result
              const USDTresult:number = parseFloat(formattedBalance) / 10 ** 12; // USDT uses 6 decimals
              const BNBResult:number = parseFloat(formattedBalanceBNB);
    
              // Set the state values
              setUsdtBalance(USDTresult);
              setBnbBalance(BNBResult);
              // console.log ("USDTresult: "+USDTresult);
              // console.log ("BNBResult: "+BNBResult);
    
          } catch (error) {
             // setError('Error fetching balances: ' + error.message);
             setpageloader(false);
          } finally {
            
          }
    
        } catch (error) {
          showAlert("Could not Connected to the MetaMask")
          // console.error("Error connecting to MetaMask:", error);
          setpageloader(false);
        }
      };
     ////-----------------------------DAPP wallet Get------------------------------
     const ValidateTransaction = async (SlotAmount:any,PackageId:any) => {
      
        const obj=
        {  WalletAddress : walletAddress,
         PayAmount : SlotAmount,
         PackageId:PackageId
    
        }
        const Param ={
          procName:'ValidateTransactionTopUp',
          Para:JSON.stringify(obj)
        }
        const result = await ExecuteProcedure(Param);
        if (result[0].StatusCode == "1") {
         
          if (bnbBalance < 0.0020) {
            
              showAlert("Insufficient bnb Balance on payment");
              // $("#cover-spin").hide();
              // return
              setpageloader(false);
          }
          if (result[0].Amount > usdtBalance) {
              
              showAlert("Insufficient USDT balance on payment");
             // $("#cover-spin").hide();
             setpageloader(false);
              return
          }
          approveAndDeposit(result[0].Amount * 10 ** 12,result[0].Amount,PackageId);
          
      } else {
        showAlert(result[0].Msg);
         // $("#cover-spin").hide();
         setpageloader(false);
      }
     }
const approveAndDeposit = async (amount:number,slotamount:number,PackageId:number) => {
  setpageloader(true);
  if (!amount || isNaN(amount)) {
    alert("Please enter a valid amount.");
    setpageloader(false);  // Hide the loading spinner
    return;
  }

  try {
    setpageloader(true);  // Show the loading spinner

    await connectWallet(); // Load Web3 and MetaMask connection
    // console.log('Web3 Loaded Successfully.');

    // console.log('Approving USDT...');
    const approvalSuccess = await approveTokens(amount,PackageId); // Step 1: Approve USDT tokens
    // console.log('USDT Approved.');

    // console.log('Depositing USDT...');
    if (approvalSuccess) {
      await depositTokens(amount,slotamount,PackageId); // Step 2: Deposit USDT tokens into your contract
      // console.log('USDT Deposited.');
    } else {
      setpageloader(false);
      showAlert("Approval failed");
    }
  } catch (error) {
    setpageloader(false); 
    console.error('Error during the approval and deposit process:', error);
    showAlert("An error occurred during the process");
  } finally {
    setpageloader(false); // Hide the loading spinner after process completes
  }
};

// Approve USDT Tokens
const approveTokens = async (amount: number,PackageId:number) => {
  try {
    if (typeof window.ethereum === 'undefined') {
      console.error('Ethereum provider is not available.');
      setpageloader(false); 
      return;
    }

    const web3 = new Web3(window.ethereum); // Use the window.ethereum provider
    await window.ethereum.request({ method: 'eth_requestAccounts' }); // Request MetaMask accounts

    const usdtContract = new web3.eth.Contract(usdtABI, usdtAddress);

    const accounts = await web3.eth.getAccounts();
    const userAddress = accounts[0]; // Get the first account
    const usdtAmount = web3.utils.toWei(amount.toString(), 'mwei'); // Convert amount to USDT (6 decimals)

    // Send approval transaction
    const receipt = await usdtContract.methods
      .approve(contractAddress, usdtAmount)
      .send({ from: userAddress });

    // Check if the transaction was successful
    if (receipt.status) {
      console.log('Approval successful');
      return true;
    } else {
      console.error('Approval failed');
      return false;
    }
  } catch (error) {
    console.error('An error occurred during approval:', error);
    alert('Approval failed. Please try again');
    setpageloader(false); 
    return false;
  }
};

// Deposit USDT Tokens
const depositTokens = async (amount:number,slotamount:number,PackageId:number) => {
  try {
    setpageloader(true);
    const contractAddress = '0xA200D4f5997Cc311f59d4C751e2C8c9aE36f99Ff'; // Contract Address
const contractABI = [{"inputs":[{"internalType":"address","name":"_usdtTokenAddress","type":"address"},{"internalType":"address","name":"_withdrawContract","type":"address"},{"internalType":"uint256","name":"_withdrawPercentage","type":"uint256"},{"internalType":"address","name":"_owner","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnerChanged","type":"event"},{"inputs":[],"name":"autoWithdrawPer","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"changeOwner","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"deposit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"withdrawPercentage","type":"uint256"}],"name":"setAutoWithdrawPer","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newWithdrawContract","type":"address"}],"name":"setWithdrawContract","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"totalDeposit","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalWithdraw","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"toWithdrawCon","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferToWithdraw","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"transferToWithdrawContract","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"usdtToken","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"userBalances","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"withdrawContract","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"}]

    //const web3 = new Web3('https://bsc-dataseed.binance.org/'); // Public BSC RPC URL
    const web3 = new Web3(window.ethereum); // Use the window.ethereum provider
    await window.ethereum.request({ method: 'eth_requestAccounts' }); // Request MetaMask accounts

    const smartContract = new web3.eth.Contract(contractABI, contractAddress);
if (typeof window.ethereum === 'undefined') {
      console.error('Ethereum provider is not available.');
      setpageloader(false);
      return;
    }

    const accounts = await web3.eth.getAccounts();
    const userAddress = accounts[0]; // Get the first account
    const usdtAmount = web3.utils.toWei(amount.toString(), "mwei"); // Convert amount to USDT (6 decimals)

     console.log('USDT Amount:', usdtAmount);

    await smartContract.methods.deposit(usdtAmount)
      .send({ from: userAddress })
      .on('transactionHash',  (hash:any)=> {
        console.log('Deposit transaction sent:', hash);
        const WalletAddress=userAddress;
        const TxnHash=hash;
        const SlotAmount=slotamount;
        debugger
       const obj= {SlotAmount,TxnHash,WalletAddress,PackageId}
        SignUP(obj);
      
      })
      .on('receipt',  (receipt:any)=> {
        console.log('Deposit transaction receipt:', receipt);
      })
      .on('error',  (error:any)=> {
        console.error('Deposit error:', error);
        showAlert("Transaction Failed");
        setpageloader(false);
      });
  } catch (error) {
    setpageloader(false);
    console.error('An error occurred during deposit:', error);
    showAlert("TDeposit failed. Please try again.");
  } finally {
    setpageloader(false);  // Hide loading spinner once done
  }
};
const SignUP=async(SignUpObj:any)=>{
    setpageloader(true);
    console.log("Form Values: ", SignUpObj); // Check if values are correct
    try {
      setpageloader(true);
      const result = await TopUpDAPP(SignUpObj);
      if (result) {
      
        console.log(result);
        var parts = result.split('|');
        var resultCode = parts[0];
        if (resultCode == "Success") {
            ShowSuccessAlert(parts[1]);
       
          setTimeout(() => {
            setpageloader(false);
            navigate(`${import.meta.env.BASE_URL}/activationReport`);
          }, 1000);
        }
        else {
           // $('#btnRegister').attr("disabled", false);
            showAlert(parts[1]);
            setpageloader(false);
        }
      
      } else {
  
      }

    } catch (error) {
      console.error("Error in registration: ", error);
      setpageloader(false);
    }
  }
   const ActivationSubmit = async (values: any) => {
  debugger
      console.log("Form Values: ", values); // Check if values are correct
      const confirmed = await ShowConfirmAlert("Activate ", "Are you sure want to activate");
      if (confirmed) {
        try {
          setpageloader(true)
          const {InvestmentAmount,PackageId} = values;
          ValidateTransaction(InvestmentAmount,PackageId);
        } catch (error) {
          console.error("Error in registration: ", error);
          setpageloader(false)
        }
      } else {
           console.log('do nothing.');
      }
     
    };
    //--------------------END-----------------------------------
  return (
    <>
      <Breadcrumbs mainTitle={Activatetitle} parent={Activatetitle} />
      <Container fluid>
      {pageloader && <Loader />}
        <Row>
        <Col md="12">
        <button className="btn-info py-2 pe-2" color="info" style={{ fontSize: '18px', textAlign: 'justify' }} type="button">
               
               {loading ? <div className="spinner-border text-light text-center" style={{ width: '1rem', height: '1rem' }} role="status">
               </div> : <span> &nbsp;{walletAddress} | USDT: {usdtBalance} | BNB: {bnbBalance}</span>}
           </button>
           <hr />
           </Col>
          <Col md="6">
           <Formik initialValues={FormFieldData || TopUpinitialValues}
                            validationSchema={validationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                             ActivationSubmit(values);
                              setSubmitting(false);
                            }}
                            enableReinitialize
                          >
                            {({ isSubmitting, values, setFieldValue, setFieldError }) => (
          <Form>
            {/* {loading && <Loader />} */}
           
            <Card>

                <CardBody>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>Package Type</Label>
                                <Field as="select" name="PackageId" className=" form-control btn-square form-select" 
                                 value={values.Packageid}
                                 onChange={(e:any)=>handlePackageChange(e,setFieldValue)}>
                                    <option value="">Package</option>
                                        {packagesList.map((pkg:any) => (
                                        <option key={pkg.PackageId}  value={pkg.PackageId}>
                                            {pkg.PackageName}
                                        </option>
                                        ))}
                                </Field>
                                 <ErrorMessage name="PackageId" component="div" className="text-danger" />
                            </FormGroup>
                            <FormGroup>
                                <Label>Activation Amount</Label>
                                <Field type="text" className="form-control" placeholder="Activation Amount" name="InvestmentAmount" 
                            
                                   readOnly={InvestmentAmountStatus}></Field>
                        <ErrorMessage name="InvestmentAmount" component="div" className="text-danger" />

                            </FormGroup>
                            <div><span className="badge badge-danger" style={{ fontSize: '18px' }}></span></div>
                        </Col>
                        <Col md="4">
                            <Btn color="primary"   disabled={isSubmitting}  style={{ marginTop: '30px'}} type="submit"
                             >Activate</Btn>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Form>
)}
                </Formik>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ActivationComponent;

